const Types = {
  GET_PROMO_CODES_SUCCESS: "GET_PROMO_CODES_SUCCESS",
  GET_PROMO_CODE_DETAILS_SUCCESS: "GET_PROMO_CODE_DETAILS_SUCCESS",
  PROMO_CODES_LOADING: "PROMO_CODES_LOADING",
  GET_SCROLL_PROMO_CODES_SUCCESS: "GET_SCROLL_PROMO_CODES_SUCCESS",
};

export default Types;
